export default "__VITE_ASSET__895857ec__"